import type React from "react";
import { FeedInputProvider } from "@/features/study-group-stream/contexts/FeedInputContext";
import { EventsContent } from "@/features/study-group-events/components/EventsContent";
import { FilesContent } from "@/features/study-group-files/components/FilesContent";
import { LinkListContent } from "@/features/study-group-link-list/components/LinkListContent";
import { StudyGroupInfo } from "@/features/study-group-info/components/StudyGroupInfo";
import { StreamContent } from "@/features/study-group-stream/components/StreamContent";

export const CHANNEL_TAB_VALUES = [
  "stream",
  "events",
  "link-list",
  "files",
  "info",
] as const;

export type ChannelTabValue = (typeof CHANNEL_TAB_VALUES)[number];

export const isChannelTabValue = (value: string): value is ChannelTabValue =>
  CHANNEL_TAB_VALUES.includes(value as ChannelTabValue);

export const StudyGroupChannelsTabContent: React.FC<{
  tab: ChannelTabValue;
}> = ({ tab }) => {
  switch (tab) {
    case "stream":
      return (
        <FeedInputProvider>
          <StreamContent />
        </FeedInputProvider>
      );
    case "events":
      return <EventsContent />;
    case "link-list":
      return <LinkListContent />;
    case "files":
      return <FilesContent />;
    case "info":
      return <StudyGroupInfo />;
    default:
      return null;
  }
};
